export default __webpack_public_path__ + "static/media/4.85a9d9d5.png";